import React, { Component } from 'react'

// core components
import GridContainer from "components/Grid/GridContainer.jsx";
import GridItem from 'components/Grid/GridItem';
import { Typography } from '@material-ui/core';

export default class DXFormResultStep extends Component {

  constructor(props) {
    super(props);

    this.state = {

    }
  }

  render() {
    return <GridContainer style={{
      backgroundColor: "white",
      justifyContent: "center",
      alignItems: "center",
      height: "311px",
      borderRadius: "6px",
      border: "solid 1px #e1e1e1",
      margin: 20,
      boxShadow: "0 1px 4px 0 rgba(0, 0, 0, 0.14)"
    }}>
      <GridItem style={{}}>
        <Typography variant="h4" align="center" style={{ fontWeight: "900", paddingBottom: 8 }}>사례관리가 저장되었습니다.</Typography>
        <Typography variant="body1" align="center">[기관사례관리]메뉴에서 확인하실 수 있습니다.</Typography>
      </GridItem>
    </GridContainer>
  }
}
